import _ from "lodash";

// components
import PostActionButton from "~/components/post/PostActionButton";
import StarIcon from "~/components/app/StarIcon";
import Icon from "@ant-design/icons/lib/components/Icon";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppModal } from "~/redux/actions/app";
import { createPostMark, deletePostMark } from "~/redux/actions/post";

const PostMarkAction = (props) => {
  const { postId, marked } = props;

  const handleMarkCreate = () => {
    if (props.token) {
      props.createPostMark(props.token, postId);
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };

  const handleMarkDelete = () => {
    if (props.token) {
      props.deletePostMark(props.token, postId);
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };

  const markCreateButton = (
    <PostActionButton
      onClick={handleMarkCreate}
      text="收藏"
      icon={<Icon component={StarIcon} style={{ fontSize: "20px" }} />}
    />
  );

  const markDeleteButton = (
    <PostActionButton
      onClick={handleMarkDelete}
      text="收藏"
      icon={<Icon component={StarIcon} style={{ fontSize: "20px" }} />}
      className="post-action-button-active"
    />
  );

  return _.includes(marked, postId) ? markDeleteButton : markCreateButton;
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createPostMark,
      deletePostMark,
      showAppModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostMarkAction);
